import React, {
  useRef,
  useState,
} from 'react';
import {
  useDispatch,
} from 'react-redux';

import {
  coreActions,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  placeCaretAtEnd,
} from 'web-utils';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  file: any;
  source: string;
  fileUpload: any;
  resourceType: string;
};

const File = ({
  file,
  source,
  fileUpload,
  resourceType,
}: Props) => {
  const dispatch = useDispatch();
  const [name, setName] = useState(file.name || '');
  const nameRef = useRef<HTMLDivElement>(null);

  const startEdit = () => {
    setTimeout(() => {
      placeCaretAtEnd(nameRef.current);
    }, 0);
  };

  const handleBlur = () => {
    const newName = nameRef.current?.textContent;
    if (file.name !== newName) {
      dispatch(
        coreActions.requestUpdateEntity({
          id: file.id,
          payload: {
            name: newName,
          },
          resourceType,
        }),
      );
    }
  };

  const handleRemove = () => {
    const filtered = Object.keys(fileUpload)
      .filter(key => key !== source)
      .reduce((acc, key) => ({
        ...acc,
        [key]: fileUpload[key],
      }), {});
    dispatch(
      uiActions.setUiState({
        fileUpload: filtered,
      }),
    );
    dispatch(
      coreActions.requestDeleteEntity({
        id: file.id,
        resourceType,
      }),
    );
  };

  return (
    <S.File>
      <Flex
        column
        flex="0 0 80%"
      >
        {file.id
          ? (
            <S.Name
              id={file.id}
              html={name}
              innerRef={nameRef}
              onChange={e => setName(e.target.value)}
              onBlur={handleBlur}
            />
          ) : (
            <S.Name
              id={file.id}
              html={file.name}
            />
          )}
        {(file.progress !== undefined) && (
          <Flex align="center" width="100%" spacing={8}>
            <Text color="#808080">
              {`${(file.size / 1000000).toFixed(2)}MB`}
            </Text>
            <S.Progress progress={file.progress} />
            <Text color="#39ca74">{`${file.progress}%`}</Text>
          </Flex>
        )}
      </Flex>
      {file.id && (
        <Flex
          align="center"
          spacing={5}
        >
          <S.Action
            icon={<SVG.PencilIcon size={14} />}
            onClick={startEdit}
          />
          <S.Action
            icon={<SVG.TrashAlt size={14} />}
            onClick={handleRemove}
          />
        </Flex>
      )}
    </S.File>
  );
};

export default File;
